const companyProfile = {
  state: {
    /*公司简介
    * Img 公司简介旁的图片链接 只需要修改require里面的路径（图片存放于assets/img/company文件夹中）
    * tel 公司的联系电话
    * telIcon 右侧固定电话图标 只需要修改require里面的路径（图片存放于assets/img/company/icon文件夹中）
    * email 公司的联系邮箱
    * emailIcon 右侧固定邮箱图标 只需要修改require里面的路径（图片存放于assets/img/company/icon文件夹中）
    * address 公司的详细地址
    * addressIcon 右侧固定地址图标 只需要修改require里面的路径（图片存放于assets/img/company/icon文件夹中）
    * wxImg 公司联系二维码 只需要修改require里面的路径（图片存放于assets/img/company/icon文件夹中）
    * wxIcon 右侧固定微信图标 只需要修改require里面的路径（图片存放于assets/img/company/icon文件夹中）
    * url 公司的网站地址
    * Content 公司描述信息
    * */
    companyInfo: {
      "Img": require('../../assets/img/company/company.jpg'),
      "tel": '138 0550 7930',
      "telIcon": require('../../assets/img/company/icon/tel.png'),
      "email": '314031851@qq.com',
      "emailIcon": require('../../assets/img/company/icon/email.png'),
      "address": "安徽省滁州市全椒县襄河镇花园桥工业园区86号",
      "addressIcon": require('../../assets/img/company/icon/address.png'),
      "wxImg": require('../../assets/img/company/icon/ercode.png'),
      "wxIcon": require('../../assets/img/company/icon/wx.png'),
      "url": "www.jindedianqi.cn",
      "Content": "安徽金得电气设备有限公司是一家集研发、生产、销售为一体的专业机柜生产商，经营范围包括电气设备、电力设备及零部件、五金制品加工、制造、销售；数控机床及附件、汽车、农业机械配套产品加工、制造、销售；建筑装饰工程设计、施工；建筑安装工程（除特种设备）、市政工程、钢结构工程施工；金属制品、不锈钢制品及室内外护栏、货架、托盘生产、销售；制冷设备、温度调节控制设备、光伏设备销售、安装。",
    },
    /*发展历程
    * Year 发展历程的时间
    * Content 具体发展内容
    * */
    courseInfo: [
      {
        "Year": "2017年06月",
        "Content": "安徽金得电气设备有限公司成立。"
      },
      {
        "Year": "2018年11月",
        "Content": "业务拓展，开始与上市公司进行商业活动。"
      },
      {
        "Year": "2019年11月",
        "Content": "与南京天加空调设备有限公司建立合作伙伴关系。"
      },
      {
        "Year": "2020年12月",
        "Content": "与江苏源江建设发展有限公司达成合作。"
      }
    ],
    /*企业文化
    * Title 企业文化标题
    * Content 企业文化内容数组
    * */
    cultureInfo: {
      "Title": "企业以人为本，员工以厂为荣",
      "Content": [
        '诚信立足，创新致远。',
        '创优质品牌，铸一流形象。',
        '没有执行力，就没有竞争力。',
        '质量是帆，企业是船，帆落船停帆鼓船进。',
      ]
    },
    /*公司荣誉证书
    * Img 荣誉证书图片 只需要修改require里面的路径（图片存放于assets/img/company/honorList文件夹中）
    * Remark 荣誉证书名称
    * */
    honorList: [
      {
        "Img": require('../../assets/img/company/honorList/honorListImg1.jpg'),
        "Remark": "ISO：9001",
      },
      {
        "Img": require('../../assets/img/company/honorList/honorListImg2.jpg'),
        "Remark": "ISO：9001",
      },
      {
        "Img": require('../../assets/img/company/honorList/honorListImg1.jpg'),
        "Remark": "建筑工程监理服务系统V1.0 软著证书",
      },
    ],
    /*车间一角
    * Img 车间一角图片 只需要修改require里面的路径（图片存放于assets/img/company/teamList文件夹中）
    * */
    teamItem: [
      {
        "Img": require('../../assets/img/company/teamList/teamListImg1.jpg'),
      },
      {
        "Img": require('../../assets/img/company/teamList/teamListImg2.jpg'),
      },
    ],
    /*合作伙伴
    * Img 合作伙伴图片 只需要修改require里面的路径（图片存放于assets/img/company/partnerList文件夹中）
    * */
    partnerImg: [
      {
        "Img": require('../../assets/img/company/partnerList/partnerListImg1.jpg'),
      },
      {
        "Img": require('../../assets/img/company/partnerList/partnerListImg2.jpg'),
      },
    ]
  },
};

export default companyProfile
